import React from 'react';
import { Card, Grid, Divider } from 'semantic-ui-react';
import ProfileModal from '../ProfileModal';
import ProfilePicture from '../ProfilePicture';
import ProfileLabel from '../../ProfileLabel';
import RequestButton from '../../Meetings/RequestButton';
import ExpertListsButton from '../../Lists/ExpertListsButton';
import CustomLink from '../../CustomLink';
import Rating from './Rating';
import ExtraInfo from './ExtraInfo';

const ExpertCard = ({ expert }) => (
  <Card className="expert-card">
    <Card.Content>
      <Card.Header>
        <ProfileModal expertId={expert.id}>
          <CustomLink>
            <ProfilePicture expert={expert} />
            {expert.fullName}
          </CustomLink>
        </ProfileModal>
      </Card.Header>
      <Grid>
        <Grid.Column style={{ paddingLeft: 0 }}>
          <Card.Meta>
            {`${expert.title}, ${expert.organization.name}`}
            <br />
            {expert.country}
          </Card.Meta>
          <Rating expert={expert} />
        </Grid.Column>
      </Grid>
      <Card.Description>
        <Grid>
          <Grid.Row>
            <ProfileLabel num={expert.credits} type="credit" />
            <ProfileLabel num={expert.numCompleted || 0} type="call" />
          </Grid.Row>
          <Grid.Row className="button-row">
            <RequestButton expert={expert} />
          </Grid.Row>
          <Grid.Row className="button-row">
            <ExpertListsButton expert={expert} />
          </Grid.Row>
          <Divider fitted />
          <Grid.Row style={{ paddingTop: 0 }}>
            <Grid.Column>
              <ExtraInfo expert={expert} />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Card.Description>
    </Card.Content>
  </Card>
);

export default ExpertCard;
